import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  Keyboard,
  Navigation,
  Pagination,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../css/PhotosVideosSlider.css";

export default function PhotosVideosSlider() {
  const galleryItems = [
    {
      type: "image",
      src: "/imagesSlider/img1.jpeg",
    },
    {
      type: "image",
      src: "/imagesSlider/img2.jpeg",
    },
    {
      type: "image",
      src: "/imagesSlider/img3.jpeg",
    },
    {
      type: "image",
      src: "/imagesSlider/img4.jpeg",
    },
    {
      type: "image",
      src: "/imagesSlider/img5.jpeg",
    },
  ];

  return (
    <section className="ms-gallery-section">
      {/* =========================================
          BACKGROUND
      ========================================= */}

      <div className="ms-gallery-grid" />

      <div className="ms-gallery-glow ms-gallery-glow-blue" />
      <div className="ms-gallery-glow ms-gallery-glow-yellow" />

      <div className="container ms-gallery-main-container">
        {/* =========================================
            HEADING
        ========================================= */}

        <div className="ms-gallery-heading-row">
          <div className="ms-gallery-heading">
            <div className="ms-gallery-kicker">
              <span />

              MOMENTS AT MINDSPARK
            </div>

            <h2>
              Inside the
              <span> Spark.</span>
            </h2>
          </div>

          <div className="ms-gallery-heading-copy">
            <p>
              A glimpse into our journey — where innovation
              meets inspiration.
            </p>

            <div className="ms-gallery-meta">
              <span className="ms-gallery-live-dot" />

              <strong>
                {galleryItems.length} moments
              </strong>

            </div>
          </div>
        </div>

        {/* =========================================
            GALLERY EXPERIENCE
        ========================================= */}

        <div className="ms-gallery-experience">
          {/* SIDE LABEL */}
          <div className="ms-gallery-side-label">
            <span>
              LEARNING
            </span>

            <strong>
              IN ACTION
            </strong>
          </div>

          {/* SWIPER */}
          <div className="ms-gallery-slider-wrap">
            <Swiper
              modules={[
                Pagination,
                Autoplay,
                Navigation,
                Keyboard,
              ]}
              slidesPerView={1}
              spaceBetween={22}
              centeredSlides
              loop
              speed={850}
              grabCursor
              keyboard={{
                enabled: true,
              }}
              navigation
              autoplay={{
                delay: 4500,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
              }}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                768: {
                  slidesPerView: 1.08,
                  spaceBetween: 26,
                },
                1100: {
                  slidesPerView: 1.18,
                  spaceBetween: 32,
                },
              }}
              className="ms-gallery-swiper"
            >
              {galleryItems.map((item, index) => (
                <SwiperSlide
                  key={`${item.src}-${index}`}
                  className="ms-gallery-slide"
                >
                  <article className="ms-gallery-card">
                    {/* NUMBER */}
                    <div className="ms-gallery-number">
                      <span>
                        MOMENT
                      </span>

                      <strong>
                        {String(index + 1).padStart(
                          2,
                          "0"
                        )}
                      </strong>
                    </div>

                    {/* MEDIA */}
                    <div className="ms-gallery-media-frame">
                      {item.type === "image" ? (
                        <img
                          src={item.src}
                          alt={`MindSpark activity ${
                            index + 1
                          }`}
                          className="ms-gallery-media"
                          loading={
                            index === 0
                              ? "eager"
                              : "lazy"
                          }
                        />
                      ) : (
                        <video
                          src={item.src}
                          className="ms-gallery-media"
                          autoPlay
                          muted
                          loop
                          playsInline
                        />
                      )}

                      <div className="ms-gallery-image-overlay" />

                      {/* CORNER BADGE */}
                      <div className="ms-gallery-image-badge">
                        <span />

                        MindSpark Moment
                      </div>

                      {/* BOTTOM TEXT */}
                      <div className="ms-gallery-image-caption">
                        <span>
                          LEARNING THROUGH TECHNOLOGY
                        </span>

                        <strong>
                          Curiosity in action.
                        </strong>
                      </div>
                    </div>

                    {/* CARD FOOTER */}
                    <div className="ms-gallery-card-footer">
                      <div className="ms-gallery-footer-left">
                        <span className="ms-gallery-small-line" />

                        <p>
                          Explore. Create. Learn.
                        </p>
                      </div>

                      <span className="ms-gallery-position">
                        {String(index + 1).padStart(
                          2,
                          "0"
                        )}
                        &nbsp;/&nbsp;
                        {String(
                          galleryItems.length
                        ).padStart(2, "0")}
                      </span>
                    </div>
                  </article>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* VERTICAL COUNTER */}
          <div className="ms-gallery-side-counter">
            <strong>
              01
            </strong>

            <span />

            {String(galleryItems.length).padStart(
              2,
              "0"
            )}
          </div>
        </div>

        {/* =========================================
            BOTTOM BRAND LINE
        ========================================= */}

        <div className="ms-gallery-bottom">
          <span />

          <p>
            Learning Through Technology
          </p>

          <span />
        </div>
      </div>
    </section>
  );
}
